import { auth } from './firebase';

/**
 * Backend URLs
 */
const CORE_BACKEND_URL = process.env.REACT_APP_CORE_BACKEND_URL;
const AI_BACKEND_URL = process.env.REACT_APP_AI_BACKEND_URL;

/**
 * Get Firebase ID token
 */
export const getAuthToken = async () => {
  const user = auth.currentUser;
  if (!user) return null;

  try {
    return await user.getIdToken(true);
  } catch (err) {
    console.error('Failed to get auth token', err);
    return null;
  }
};

/**
 * Internal fetch helper
 */
const apiFetchInternal = async (baseUrl, path, options = {}) => {
  const method = options.method?.toUpperCase() || 'GET';
  const isPreflight = method === 'OPTIONS';

  let headers = {
    ...(options.headers || {}),
  };

  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (!isPreflight) {
    const token = await getAuthToken();
    if (!token) throw new Error('Not authenticated');
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    let err = {};
    try {
      err = await response.json();
    } catch (_) {}

    throw new Error(
      err.error ||
      err.message ||
      `Request failed (${response.status})`
    );
  }

  if (response.status === 204) return null;

  return response.json();
};

/**
 * 🔹 Core backend (plans, subscriptions, user)
 */
export const coreApiFetch = (path, options) =>
  apiFetchInternal(CORE_BACKEND_URL, path, options);

/**
 * 🔹 AI tools backend (generation, tools)
 */
export const aiApiFetch = (path, options) =>
  apiFetchInternal(AI_BACKEND_URL, path, options);

/**
 * Backward-compatible POST helper (AI backend default)
 */
export const authenticatedApiCall = async (endpoint, data) => {
  return aiApiFetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * ✅ Compatibility export
 * Existing code importing `apiFetch` will now work
 */
export const apiFetch = (path, options) =>
  coreApiFetch(path, options);
